var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-20684.002 -23679 15 15"}},[_c('path',{attrs:{"d":"M-20677.504-23665v-5.5h-5.5a1 1 0 0 1 0-2h5.5v-5.5a1 1 0 1 1 2 0v5.5h5.5a1 1 0 0 1 0 2h-5.5v5.5a1 1 0 1 1-2 0z","data-name":"Union 37","fill":"#fff","opacity":".87"}})])};var toString = function () {return "/Library/WebServer/Documents/iwp-vue-client/iwp-vue-client/src/assets/plus.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/plus.svg
// module id = 1bhZ
// module chunks = 3